import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useTheme } from '../../../../contexts/ThemeContext'

const TestPieChart = ({ data, labels, title, height = 350, colors }) => {
  const { theme } = useTheme()
  const [chartData, setChartData] = useState(null)

  useEffect(() => {
    const labelColor = theme === 'dark' ? '#d1d5db' : '#6b7280'
    renderChart(labelColor)
  }, [data, labels, theme])

  const renderChart = (labelColor) => {
    setChartData({
      series: Array.isArray(data) ? data : [0, 0, 0],
      options: {
        labels: Array.isArray(labels) && labels.length ? labels : ['A', 'B', 'C'],
        colors: Array.isArray(colors) && colors.length ? colors : undefined,
        legend: {
          position: 'bottom',
          horizontalAlign: 'left',
          floating: false,
          fontSize: '14px',
          fontFamily: 'Inter',
          fontWeight: 400,
          labels: {
            colors: undefined,
            useSeriesColors: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 300 },
              legend: { position: 'bottom' },
            },
          },
        ],
      },
    })
  }

  return (
    <div className="overflow-hidden sm:rounded-lg bg-white dark:bg-darkbg4 px-4 py-3 border">
      <h3 className="text-left px-6">{title}</h3>
      {chartData && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="pie"
          fontFamily="DM Sans, sans-serif"
          height={height}
        />
      )}
    </div>
  )
}

export default TestPieChart
